import React from 'react'

const TextField = ({ name, label, value, placeholder, errors, onChange }) => (
  <div className="form-group">
    {label ? <label htmlFor={name}>{label}</label> : null}
    <input
      className={`form-control ds-text-input ${errors ? 'is-invalid' : ''}`.trim()}
      type="text"
      name={name}
      id={name}
      value={value}
      placeholder={placeholder}
      onChange={onChange}
    />
    {errors ? <small className="text-danger">{errors[0]}</small> : null}
  </div>
)

export default TextField
